<template lang="pug">
	section#mapa
		#map(ref="map")
		button.customControl(ref="controlCenter", title="Centralizar o mapa", @click="centerMap()")
			include ../../../assets/svgs/icones/icone_center-map.svg
		AsidePolo(:tipo="tipo")
</template>

<script>
import Polo, { GOOGLEMAPS_STYLES } from '@views/Unidades/Polo.js'
import AsidePolo from '@components/Polo/Polo'

export default {
	name: "section-mapa",
	components: {
		AsidePolo,
	},
	props: {
		tipo: {
			type: [String, null],
			default: 'grad'
		},
		estado: {
			type: [String, null],
			default: null
		},
		cidade: {
			type: [String, null],
			default: null
		},
		endereco: {
			type: [String, null],
			default: null
		},
		estados: {
			type: Array,
			default: () => []
		},
		cidades: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			polos: [],
			map: null,
			center: null,
			service: null,
			enderecoLatLng: null,
			userMarker: null,
		}
	},
	watch: {
		tipo: function () {
			this.loadPolos(this.tipo)
		},
		estado: function() {
			if (this.estado == null) {
				this.centerMap()
			} else {
				let latlng = this.estados.find(estado => estado.uf == this.estado).latlng
				// eslint-disable-next-line
				this.centerMap(new google.maps.LatLng(latlng.lat, latlng.lng), 6)
			}
		},
		cidade: function () {
			if (this.estado == null && this.cidade == null) {
				this.centerMap()
			} else if (this.cidade == null) {
				let latlng = this.estados.find(estado => estado.uf == this.estado).latlng
				// eslint-disable-next-line
				this.centerMap(new google.maps.LatLng(latlng.lat, latlng.lng), 6)
			} else {
				let latlng = this.cidades.find(cidade => cidade.slug == this.cidade).latlng
				// eslint-disable-next-line
				this.centerMap(new google.maps.LatLng(latlng.lat, latlng.lng), 11)
			}
		}
	},
	created() {
		this.$eventbus.$on('gmaps-loaded', this.loadPolos)
	},
	methods: {
		loadPolos(tipo = null) {
			this.$axios
				.get(`polos/${tipo || 'grad'}`)
				.then(response => {
					this.polos.forEach(polo => polo.marker.setMap(null))
					this.polos = response.data.registros.map(polo => new Polo(polo, polo.Nome))
				})
				.then(() => !this.map ? this.initMap() : true)
				.then(() => this.polos.forEach(polo => this.initMarker(polo)))
				.then(() => this.$eventbus.$emit('polos-loaded'))
		},
		initMarker(polo) {
			if (polo.latLng) {
				// eslint-disable-next-line
				polo.marker = new google.maps.Marker({
					// eslint-disable-next-line
					position: new google.maps.LatLng(polo.latLng.lat, polo.latLng.lng),
					map: this.map
				})

				polo.marker.addListener('click', () => {
					// eslint-disable-next-line
					this.map.panTo(new google.maps.LatLng(polo.latLng.lat, polo.latLng.lng))
					this.map.setZoom(13)
					this.$eventbus.$emit('show-polo', polo)
				})
			}
		},
		initMap() {
			// eslint-disable-next-line
			this.center = new google.maps.LatLng(-13.7043008, -50.7263942)
			// eslint-disable-next-line
			this.map = new google.maps.Map(this.$refs.map, {
				center: this.center,
				zoom: 3,
				styles: GOOGLEMAPS_STYLES,
				mapTypeControl: false,
				streetViewControl: false,
				zoomControlOptions: {
					// eslint-disable-next-line
					position: google.maps.ControlPosition.RIGHT_TOP,
				},
			})
			// eslint-disable-next-line
			this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(this.$refs.controlCenter);
		},
		centerMap(center, zoom = 3) {
			center = center || this.center
			this.map.panTo(center);
			this.map.setZoom(zoom)
		},
		sendEndereco(){
			this.$axios.get('https://maps.googleapis.com/maps/api/geocode/json?address='+this.estado + ' - ' +this.cidade + ', ' + this.endereco+'&key='+this.$utils.google_maps_api)
			.then(response => {
				if(response.data && response.data.results && response.data.results[0] && response.data.results[0].geometry){
					this.enderecoLatLng = response.data.results[0].geometry.location;
					let distancesRaw  = [];
					this.polos.forEach(polo => {
						let distance = this.distance(this.enderecoLatLng.lat,this.enderecoLatLng.lng,polo.latLng.lat, polo.latLng.lng );
						distancesRaw.push({latLng:polo.latLng,distance:distance});
					});
					distancesRaw.sort(function (a,b) {
						if(a.distance > b.distance )
							return 1;
						if(a.distance < b.distance)
							return -1;
						if(a.distance == b.distance)
							return 0;
					});
					let destinations = [];
					let origins = [];
					origins.push(this.endereco);
					for (let i = 0; i < 10; i++){
						// eslint-disable-next-line
						destinations.push(new google.maps.LatLng(distancesRaw[i].latLng.lat, distancesRaw[i].latLng.lng));
					}
					if(this.service === null){
						// eslint-disable-next-line
						this.service = new google.maps.DistanceMatrixService();
					}

					this.service.getDistanceMatrix({
						origins: origins,
						destinations: destinations,
						travelMode: 'DRIVING',
					},this.callBackEndereco);
					// console.log(destinations);
					// console.log(this.service);
				}else{
					alert('Tente novamente mais tarde');
				}
			});
		},
		callBackEndereco(response, status){
			if(status == "OK" && response.destinationAddresses && response.destinationAddresses[0]){
				this.$axios.get('https://maps.googleapis.com/maps/api/geocode/json?address='+response.destinationAddresses[0]+'&key='+this.$utils.google_maps_api)
				.then(response => {
					if(response.data && response.data.results && response.data.results[0] && response.data.results[0].geometry){
						let latLng = response.data.results[0].geometry.location;
						this.polos.forEach(polo => {
							if(latLng.lat == polo.latLng.lat && latLng.lng == polo.latLng.lng){
								// eslint-disable-next-line
								let directionsService = new google.maps.DirectionsService();
								// eslint-disable-next-line
								let directionsRenderer = new google.maps.DirectionsRenderer({
									suppressMarkers: true,
									suppressInfoWindows: true,
								});
								directionsRenderer.setMap(this.map);
								let request = {
									origin: this.enderecoLatLng,
									destination: latLng,
									travelMode: 'DRIVING'
								};
								directionsService.route(request, (result, status) => {
									if (status == 'OK') {
										directionsRenderer.setDirections(result);
										if (!this.userMarker) {
											// eslint-disable-next-line
											this.userMarker = new google.maps.Marker({
												position: this.enderecoLatLng,
												label: 'A',
												map: this.map,
											})
										}
										polo.marker.setLabel('B')
									}
								});
								// eslint-disable-next-line
								google.maps.event.trigger( polo.marker, 'click' );
							} else {
								polo.marker.setLabel('')
							}
						});
					}else{
						alert('Tente novamente mais tarde');
					}
				});

			}else{
				alert('Tente novamente mais tarde');
			}

		},
		distance(lat1, lon1, lat2, lon2) {
			let radlat1 = Math.PI * lat1/180;
			let radlat2 = Math.PI * lat2/180;
			let theta = lon1-lon2;
			let radtheta = Math.PI * theta/180;
			let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
			if (dist > 1) {
				dist = 1;
			}
			dist = Math.acos(dist);
			dist = dist * 180/Math.PI;
			dist = dist * 60 * 1.1515;
			dist = dist * 1.609344;
			return dist
		}
	},
}
</script>

<style lang="stylus" scoped src="./Mapa.styl"></style>
